import * as React from "react";

export interface WarningIconProps {
  className?: string;
}

export const WarningIcon: React.FC<WarningIconProps> = ({ className }) => {
  return (
    <svg
      width="76"
      height="76"
      viewBox="0 0 76 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="76" height="76" fill="#ED3431" />
      <path
        d="M38.0018 13C38.7189 13.0001 39.4237 13.1893 40.0447 13.5479C40.6657 13.9064 41.1813 14.422 41.5399 15.043L66.2645 57.8682V57.8691C66.6232 58.4903 66.8122 59.1948 66.8123 59.9121C66.8124 60.6295 66.6241 61.3347 66.2654 61.9561C65.9068 62.5773 65.3906 63.0934 64.7693 63.4521C64.148 63.8109 63.4428 64 62.7254 64H13.2752C12.5577 64.0001 11.8526 63.8109 11.2313 63.4521C10.6099 63.0934 10.0939 62.5775 9.73517 61.9561C9.37644 61.3347 9.18725 60.6296 9.18732 59.9121C9.18745 59.1948 9.37649 58.4903 9.73517 57.8691V57.8682L34.4627 15.043C34.8213 14.422 35.3369 13.9064 35.9578 13.5479C36.579 13.1892 37.2845 13 38.0018 13Z"
        fill="#8E1F1D"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M39.405 28.4078H36.796C35.3623 28.4078 34.2 29.57 34.2 31.0038L35.2133 45.439C35.2133 46.8727 36.3756 48.035 37.8094 48.035H38.3917C39.8255 48.035 40.9877 46.8727 40.9877 45.439L42.0011 31.0038C42.0011 29.57 40.8388 28.4078 39.405 28.4078Z"
        fill="white"
      />
      <path
        d="M38.1005 56.8629C39.6951 56.8629 40.9877 55.5703 40.9877 53.9757C40.9877 52.3812 39.6951 51.0885 38.1005 51.0885C36.506 51.0885 35.2133 52.3812 35.2133 53.9757C35.2133 55.5703 36.506 56.8629 38.1005 56.8629Z"
        fill="white"
      />
    </svg>
  );
};
